import { fetchWithAuth } from "./FetchWithAuth";
import { url } from "./url";

const base = `${String(url).replace(/\/+$/, "")}/appointments`;

async function request(path, options = {}, auth = true) {
  const endpoint = `${base}${path}`;
  const fetcher = auth ? fetchWithAuth : fetch;
  const response = await fetcher(endpoint, {
    credentials: auth ? "include" : "omit",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });
  if (!response) {
    return {};
  }
  return response.json();
}

export const appointmentsApi = {
  getTypes: () => request("/types"),
  createType: (payload) => request("/types", { method: "POST", body: JSON.stringify(payload) }),
  updateType: (id, payload) => request(`/types/${id}`, { method: "PUT", body: JSON.stringify(payload) }),
  deleteType: (id) => request(`/types/${id}`, { method: "DELETE" }),

  listAppointments: (params = {}, options = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(qs ? `?${qs}` : "", options);
  },
  getAppointment: (id) => request(`/${id}`),
  createAppointment: (payload) => request("", { method: "POST", body: JSON.stringify(payload) }),
  updateAppointment: (id, payload) => request(`/${id}`, { method: "PUT", body: JSON.stringify(payload) }),
  cancelAppointment: (id, payload) => request(`/${id}/cancel`, { method: "POST", body: JSON.stringify(payload) }),
  rescheduleAppointment: (id, payload) => request(`/${id}/reschedule`, { method: "POST", body: JSON.stringify(payload) }),
  completeAppointment: (id) => request(`/${id}/complete`, { method: "POST" }),

  getAvailability: (params, options = {}) => {
    const { auth = true, ...requestOptions } = options;
    const qs = new URLSearchParams(params).toString();
    return request(`/availability?${qs}`, requestOptions, auth);
  },
  getPublicBookingAvailability: (token, params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(
      `/booking-links/${encodeURIComponent(token)}/availability${qs ? `?${qs}` : ""}`,
      {},
      false
    );
  },
  getRoster: (counsellorId) => request(`/availability/roster?counsellor_id=${counsellorId}`),
  updateRoster: (payload) => request("/availability/roster", { method: "PUT", body: JSON.stringify(payload) }),
  listExceptions: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/availability/exceptions${qs ? `?${qs}` : ""}`);
  },
  createException: (payload) => request("/availability/exceptions", { method: "POST", body: JSON.stringify(payload) }),
  deleteException: (id) => request(`/availability/exceptions/${id}`, { method: "DELETE" }),

  listBookingLinks: () => request("/booking-links"),
  generateBookingLink: (payload) => request("/booking-links", { method: "POST", body: JSON.stringify(payload) }),
  validateBookingLink: (token) => request(`/booking-links/${token}/validate`, {}, false),
  publicBook: (token, payload) =>
    request(`/booking-links/${token}/book`, { method: "POST", body: JSON.stringify(payload) }, false),

  connectOutlook: (payload) => request("/outlook/connect", { method: "POST", body: JSON.stringify(payload) }),
  getOutlookStatus: () => request("/outlook/status"),
  syncOutlook: () => request("/outlook/sync", { method: "POST" }),
  disconnectOutlook: () => request("/outlook/disconnect", { method: "POST" }),
  runReminderSweep: () => request("/reminders/run", { method: "POST" }),
};
